export const ALL_CATEGORY_SECTIONS = ['property', 'chain', 'market'];
export const PROPERTY_CATEGORY_SECTION = ['property'];
export const PROPERTY_AND_MARKET_SECTIONS = ['property', 'market'];
export const CHAIN_CATEGORY_SECTION = ['chain'];
export const PROPERTY_AND_CHAIN_CATEGORY_SECTION = ['property', 'chain'];
export const MARKET_CATEGORY_SECTION = ['market'];
